import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useLocation } from "react-router-dom";
import axios from "axios";
import People from "../ui-components/people/People";
import Blogsearch from "../ui-components/blogs/Blogsearch";
import Question from "../ui-components/question/Question";
import API_ENDPOINT from "../wm.api.service";
import "./search.css";
import Cookies from "universal-cookie";
import { connect } from "react-redux";

// ACTIONS
// import { getQuerySting } from "../services/actions/actions";
import { decode } from "base-64";

const cookies = new Cookies();
function Search({ rootData }) {
  var token = cookies.get("wmtoken");
  const location = useLocation();
  const [tabIndex, setTabIndex] = useState(0);
  useEffect(() => {
    document.body.style.backgroundColor = "#f0f2f6";
    return () => {
      document.body.style.backgroundColor = "";
    };
  });
  const [people, setPeople] = useState([]);
  const [blog, setBlog] = useState([]);
  const [question, setQuestion] = useState([]);
  const queryString = window.location.search;
  const parameter = new URLSearchParams(queryString);
  const value = parameter.get("search_query");
  const getSearchedItem = () => {
    var fd = new FormData();
    if (token) {
      fd.append("token", decode(token));
      fd.append("identity", "wmhandler");
    }
    fd.append("search_key", value);
    fd.append("search_position", "PAGE");
    fd.append("screen_name", "ALL");
    fd.append("page_No", 0);
    axios({
      url: `${API_ENDPOINT.apiURL}Profile/search`,
      method: "POST",
      data: fd,
    })
      .then(function (response) {
        setPeople(response.data.people);
        setBlog(response.data.blog);
        setQuestion(response.data.question);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  useEffect(() => {
    getSearchedItem();
    // setQuery(value);
    return () => {
      getSearchedItem();
    };
  }, [location]);

  const [onlyPeople, setOnlyPeople] = useState([]);
  const [onlyBlog, setOnlyBlog] = useState([]);
  const [onlyQuestion, setOnlyQuestion] = useState([]);
  const getOnlySpecificTabContent = (tabIdx, tabName) => {
    setTabIndex(tabIdx);
    var fd = new FormData();
    if (token) {
      fd.append("token", decode(token));
      fd.append("identity", "wmhandler");
    }
    fd.append("search_key", value);
    fd.append("search_position", "PAGE");
    fd.append("screen_name", tabName);
    fd.append("page_No", 0);
    axios({
      url: `${API_ENDPOINT.apiURL}Profile/search`,
      method: "POST",
      data: fd,
    })
      .then(function (response) {
        if (tabName === "PEOPLE") {
          setOnlyPeople(response.data);
        }
        if (tabName === "BLOG") {
          setOnlyBlog(response.data);
        }
        if (tabName === "QUESTION") {
          setOnlyQuestion(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <React.Fragment>
      <Tabs
        className="search_tabs mt-28"
        selectedIndex={tabIndex}
        onSelect={(index) => setTabIndex(index)}
      >
        <Container>
          <Row>
            <Col md={2} className="mt-3 relative lg:fixed w-full">
              <TabList className="search_tabs w-full">
                <Tab className="w-24 pl-3 text-gray-400 cursor-pointer mb-2 relative">
                  All
                </Tab>
                <Tab
                  className="w-24 pl-3 text-gray-400 cursor-pointer mb-2 relative"
                  onClick={() => getOnlySpecificTabContent(1, "PEOPLE")}
                >
                  People
                </Tab>
                <Tab
                  className="w-24 pl-3 text-gray-400 cursor-pointer mb-2 relative"
                  onClick={() => getOnlySpecificTabContent(2, "BLOG")}
                >
                  Blog
                </Tab>
                <Tab
                  className="w-24 pl-3 text-gray-400 cursor-pointer mb-2 relative"
                  onClick={() => getOnlySpecificTabContent(3, "QUESTION")}
                >
                  Questions
                </Tab>
              </TabList>
            </Col>
            <Col md={10} className="ml-40">
              <div>
                <TabPanel>
                  {/* People */}
                  {people?.length > 0 ? (
                    <div className="tab-container-search">
                      <h4>People</h4>
                      <div className="search__people--Container">
                        {people.map((peopleData, idx) => {
                          return (
                            <People
                              key={idx}
                              peopleData={peopleData}
                              className="mb-3"
                            />
                          );
                        })}
                      </div>
                      <div className="text-center mb-3 bg-gray-300 py-2 rounded">
                        <a
                          href={void 0}
                          className="show_more--search text-sm block cursor-pointer"
                          onClick={() => getOnlySpecificTabContent(1, "PEOPLE")}
                        >
                          Show more
                        </a>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* Blogs */}
                  {blog?.length > 0 ? (
                    <div className="tab-container-search">
                      <h4>Blogs</h4>
                      <div className="search__people--Container">
                        {blog.map((blogData, idx) => {
                          return (
                            <Blogsearch
                              key={idx}
                              blogData={blogData}
                              className="p-2 mb-3 blog_search--border-b"
                            />
                          );
                        })}
                      </div>
                      <div className="text-center mb-3 bg-gray-300 py-2 rounded">
                        <a
                          href={void 0}
                          className="show_more--search text-sm block cursor-pointer"
                          onClick={() => getOnlySpecificTabContent(2, "BLOG")}
                        >
                          Show more
                        </a>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* Questions */}
                  {question?.length > 0 ? (
                    <div className="tab-container-search">
                      <h4>Questions</h4>
                      <div className="search__people--Container">
                        {/* <Question className="p-2 mb-3" questionData={question} /> */}
                        {question.map((questionData, idx) => {
                          return (
                            <Question
                              key={idx}
                              questionData={questionData}
                              className="p-2 mb-3 blog_search--border-b"
                            />
                          );
                        })}
                      </div>
                      <div className="text-center mb-3 bg-gray-300 py-2 rounded">
                        <a
                          href={void 0}
                          className="show_more--search text-sm block cursor-pointer"
                          onClick={() =>
                            getOnlySpecificTabContent(3, "QUESTION")
                          }
                        >
                          Show more
                        </a>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </TabPanel>
                <TabPanel>
                  <div className="search__people--Container">
                    {onlyPeople.map((peopleData, idx) => {
                      return (
                        <People
                          key={idx}
                          peopleData={peopleData}
                          className="mb-3"
                        />
                      );
                    })}
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="search__people--Container">
                    {onlyBlog.map((blogData, idx) => {
                      return (
                        <Blogsearch
                          key={idx}
                          blogData={blogData}
                          className="p-2 mb-3 blog_search--border-b"
                        />
                      );
                    })}
                  </div>
                </TabPanel>
                <TabPanel>
                  {onlyQuestion.length > 0 ? (
                    <div className="search__people--Container">
                      {onlyQuestion.map((questionData, idx) => {
                        return <Question key={idx} className="p-2 mb-3" questionData={questionData} />;
                      })}
                    </div>
                  ) : (
                    ""
                  )}
                </TabPanel>
              </div>
            </Col>
          </Row>
        </Container>
      </Tabs>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

// const mapDispatchToState = (dispatch) => {
//   return {
    
//   };
// };

export default connect(mapStateToProps, null)(Search);
